import React from "react";
import { ReactComponent as DownIcon } from "../../assets/icons/table/down.svg";
import { ReactComponent as UpIcon } from "../../assets/icons/table/up.svg";
import { IProduct } from "../../types/product.type";
import styles from "./styles.module.scss";

interface Props {
  products: IProduct[];
  onClickRow: (index: number, direction: "up" | "down") => void;
}

const ProductsOrderTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th></th>
          <th>Продукт</th>
          <th>Бренд</th>
          <th>Capacity</th>
          <th>Price</th>
          <th>Статус</th>
        </tr>
      </thead>
      <tbody>
        {props.products &&
          props.products.map((product, index) => (
            <tr key={product.id}>
              <td>
                <div className={styles.controllerContainer}>
                  <button
                    className={styles.controllerButton}
                    onClick={() => props.onClickRow(index, "up")}
                  >
                    <UpIcon className={styles.controllerIcon} />
                  </button>
                  <button className={styles.controllerButton}>
                    <DownIcon
                      className={styles.controllerIcon}
                      onClick={() => props.onClickRow(index, "down")}
                    />
                  </button>
                </div>
              </td>
              <td>
                <div className={styles.userInfo}>
                  {product.previewImageUrl ? (
                    <img
                      src={product.previewImageUrl}
                      className={styles.avatar}
                      alt="Avatar"
                    />
                  ) : (
                    <div className={styles.avatarEmpty}></div>
                  )}
                  <div className={styles.nameContainer}>
                    <span className={styles.name}>{product.name}</span>
                  </div>
                </div>
              </td>
              <td className={styles.role}>{product.brand.name}</td>
              <td className={styles.role}>{product.capacity}</td>
              <td className={styles.role}>
                {product.price}/{product.wholeSalePrice}
              </td>
              <td className={styles.role}>
                {product.avaliable ? "Опубліковано" : "Не опубліковано"}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default ProductsOrderTable;
